const userApplicationServiceDictionary = {
  getApplicationFormData: (token: string, applicationId: string) =>
    `api/v1/user-application/fetch?applicationId=${applicationId}`,

  getApplication: (
    token: string,
    status?: string,
    page?: number,
    limit?: number
  ) => {
    const params = new URLSearchParams();

    if (status) {
      params.append("status", status);
    }
    if (page !== undefined && page !== null) {
      params.append("page", page.toString());
    }
    if (limit !== undefined && limit !== null) {
      params.append("limit", limit.toString());
    }

    const queryString = params.toString();
    return queryString
      ? `api/v1/user-application/fetch?${queryString}`
      : `api/v1/user-application/fetch?limit=4&page=1`;
  },

  updateFirstTimeViewOnlyPopupsFlags: () =>
    "api/v1/user-application/update-popup-status",

  partnerApplicationFetch: (applicationId: string) =>
    `api/v1/user-application/partner-application-fetch?applicationId=${applicationId}`,
};

export default userApplicationServiceDictionary;
